import { __assign, __spreadArray, __read } from 'tslib';
import React__default from 'react';
import { useTextCopy } from '@invitae/cms-blocks';
import { useMinMediaQuery } from '@invitae/react-hooks';
import { useRenderControl } from '../../../hooks/useRenderControl.esm.js';
import { useUserButtonConfig } from '../components/NavigationHeader.hooks.esm.js';
import NavigationHeaderDesktopComponent from '../components/NavigationHeaderDesktop/NavigationHeaderDesktopComponent.esm.js';
import NavigationHeaderMobileComponent from '../components/NavigationHeaderMobile/NavigationHeaderMobileComponent.esm.js';
import classes from '../components/NavigationHeader.module.esm.js';

var pathsToHideCtaButton = ['/providers/test-catalog'];
var GlobalNavigation = function (_a) {
    var BaseComponent = _a.BaseComponent, search = _a.search, navigationElements = _a.navigationElements;
    var _b = ((search === null || search === void 0 ? void 0 : search.fields) || {}).suggestionLinks, suggestionLinks = _b === void 0 ? [] : _b;
    var isLargeOrUp = useMinMediaQuery(1020);
    var isRendered = useRenderControl().isRendered;
    var getText = useTextCopy().getText;
    var defaultSuggestions = suggestionLinks.reduce(function (acc, link) {
        var _a, _b, _c;
        var links = ((_b = (_a = link === null || link === void 0 ? void 0 : link.fields) === null || _a === void 0 ? void 0 : _a.linkScheme) === null || _b === void 0 ? void 0 : _b.fields) || {};
        var _d = __assign({}, links), _e = _d.url, url = _e === void 0 ? '' : _e, _f = _d.path, path = _f === void 0 ? '' : _f;
        return __spreadArray(__spreadArray([], __read(acc), false), [
            {
                result: ((_c = link === null || link === void 0 ? void 0 : link.fields) === null || _c === void 0 ? void 0 : _c.text) || '',
                url: url || path,
            },
        ], false);
    }, []);
    var signInButtonConfig = useUserButtonConfig({
        myAccountText: getText('signInLogged'),
        signInText: getText('signIn'),
    });
    if (!navigationElements || !isRendered)
        return null;
    return (React__default.createElement(React__default.Fragment, null, isLargeOrUp ? (React__default.createElement(NavigationHeaderDesktopComponent, { BaseComponent: BaseComponent, className: classes.desktopNav, defaultSuggestions: defaultSuggestions, navigationElements: navigationElements, pathsToHideCtaButton: pathsToHideCtaButton, signInButtonConfig: signInButtonConfig })) : (React__default.createElement(NavigationHeaderMobileComponent, { BaseComponent: BaseComponent, className: classes.mobileNav, defaultSuggestions: defaultSuggestions, navigationElements: navigationElements, pathsToHideCtaButton: pathsToHideCtaButton, signInButtonConfig: signInButtonConfig }))));
};

export { GlobalNavigation, GlobalNavigation as default };
//# sourceMappingURL=GlobalNavigation.esm.js.map
